import Box from '@mui/material/Box'
import { SxProps } from '@mui/material/styles'
import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'

export const AnimateHeight: React.FC<React.PropsWithChildren<{
  duration?: number
  sx?: SxProps
}>> = ({ children, duration = 1, ...props }) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [height, setHeight] = useState<number | 'auto'>('auto')

  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        // We only have one entry, so we can use entries[0].
        const observedHeight = entries[0].contentRect.height
        setHeight(observedHeight)
      })

      resizeObserver.observe(containerRef.current)

      return () => {
        // Cleanup the observer when the component is unmounted
        resizeObserver.disconnect()
      }
    }
    return
  }, [])

  return (
    <Box
      component={motion.div}
      animate={{ height }}
      transition={{ duration }}
      sx={{
        height,
        overflow: 'hidden',
        ...(props.sx || {}),
      }}
    >
      <div ref={containerRef}>{children}</div>
    </Box>
  )
}